import * as RadixTabs from '@radix-ui/react-tabs'
import { clsx } from 'clsx'
import type { ReactNode } from 'react'

// TailAdmin's underline tab (demo.tailadmin.com/tabs, second variant): a gray-200 rule under
// -mb-px triggers, active = brand-500 text + 2px brand-500 underline. Roving tabindex,
// arrow/home/end navigation and role=tablist/tab/tabpanel come from Radix itself.

export function Tabs({ value, onValueChange, children, className }: {
  value: string
  onValueChange: (value: string) => void
  children: ReactNode
  className?: string
}) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={className}>
      {children}
    </RadixTabs.Root>
  )
}

export function TabsList({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={clsx('border-b border-gray-200', className)}>
      <RadixTabs.List className="-mb-px flex space-x-2 overflow-x-auto no-scrollbar">
        {children}
      </RadixTabs.List>
    </div>
  )
}

export function TabsTrigger({ value, children }: { value: string; children: ReactNode }) {
  return (
    <RadixTabs.Trigger
      value={value}
      className="inline-flex items-center gap-2 border-b-2 border-transparent px-2.5 py-2 text-sm font-medium text-gray-500 whitespace-nowrap transition-colors duration-200 ease-in-out hover:text-gray-700 data-[state=active]:border-brand-500 data-[state=active]:text-brand-500 focus-visible:outline-none focus-visible:shadow-focus-ring rounded-t-md"
    >
      {children}
    </RadixTabs.Trigger>
  )
}

export function TabsContent({ value, children, className }: { value: string; children: ReactNode; className?: string }) {
  return (
    <RadixTabs.Content value={value} className={className}>
      {children}
    </RadixTabs.Content>
  )
}
